import { render } from "./SpeakersListVariant.vue?vue&type=template&id=1d28a3e4"
import script from "./SpeakersListVariant.vue?vue&type=script&lang=js"
export * from "./SpeakersListVariant.vue?vue&type=script&lang=js"

import "./SpeakersListVariant.vue?vue&type=style&index=0&id=1d28a3e4&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__